module.exports = __webpack_public_path__ + "static/social-banner-a4f062ed11d6f5d01dccead35cd289ef.jpg";